<div
  *ngIf="isVisible"
  class="heat-map-container"
  leaflet
  [leafletOptions]="options"
  [leafletLayers]="layers"
></div>
